export default __webpack_public_path__ + "static/media/afficheBlur.9eb8c54d.jpg";